export default __webpack_public_path__ + "static/media/harvey-yu.9610923d.jpeg";